import { render } from "./case-study.vue?vue&type=template&id=1581f4c4&scoped=true"
import script from "./case-study.vue?vue&type=script&lang=js"
export * from "./case-study.vue?vue&type=script&lang=js"

import "./case-study.vue?vue&type=style&index=0&id=1581f4c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1581f4c4"

export default script